export default "__VITE_ASSET__8eced883__"